export default __webpack_public_path__ + "static/media/Richa Awasthi .545ad2f5.jpg";